import AppHeader from '../AppHeader'

export default {
  name: 'question-detail',
  created () {
    this.search()
  },
  data () {
    return {
      title: '',
      questions: [
        {content: null, displayOrder: 1}
      ],
      canValidate: true
    }
  },
  computed: {
    validation: function () {
      var v = {
        title: !!this.title,

        not_input: !!this.title
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      this.$store.dispatch('GET_QUESTION_DETAIL', { id: this.$route.params.id })
      .then(res => {
        this.title = res.title.title
        if (res.question_details.length > 0) {
          this.questions = res.question_details
        }
      })
      .catch(err => console.log(err))
    },
    onClickSave: function () {
      this.$store.dispatch('QUESTION_UPDATE', {
        id: this.$route.params.id,
        data: {
          title: this.title,
          contents: this.questions
        }
      })
      .then(res => {
        console.log('QUESTION_UPDATE_SUCCESS')
        this.$router.push({path: '/question'})
      })
      .catch(err => console.log(err))
    },
    onClickCancel: function () {
      this.$router.push('/question')
    },
    addContent: function (index) {
      let question = {content: null}
      this.questions.splice(index + 1, 0, question)
    },
    deleteContent: function (index) {
      this.questions.splice(index, 1)
    },
    newLineContent: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/question-detail.js